import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Stkmw { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '交易所代號 (MW001) 不可空白'}) 
    @MaxLength(8,{message: '交易所代號 (MW001) 資料太長'})
    MW001: string = '';            // 交易所代號 8 

    @MaxLength(40,{message: '交易所名稱 (MW002) 資料太長'})
    MW002: string = '';            // 交易所名稱 40 

    @MaxLength(255,{message: '備註 (MW003) 資料太長'})
    MW003: string = '';            // 備註 255 


}
